import React, { useState } from "react";
import "./App.css";
import searchIcon from "../../assets/search.svg";
import { checkHashFormat, getCurrentUrl, navigate } from "../utilities";
import {
  getBBData,
  getBlockHashData,
  getDocumentData,
} from "../Api";

type ErrorState = { message: string; title?: string } | null;

function SearchBar({
  onSearchStringChange,
  value,
  setLoading,
  setError,
}: {
  onSearchStringChange: (value: string) => void;
  value: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<ErrorState>>;
}) {
  const [searchHash, setSearchHash] = useState(value);

  const handleSearchSubmit = async (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => {
    e.preventDefault();
    const currentUrl = getCurrentUrl();

    const hash = (value || searchHash).trim();
    if (!hash) return;

    const isSha256 = checkHashFormat(hash);
    const isMd5 = checkHashFormat(hash, "md5");
    const looksLikeTxId = /^[A-Za-z0-9]{20,128}$/.test(hash);

    if (!isSha256 && !isMd5 && !looksLikeTxId) {
      setError({
        title: "Invalid input",
        message:
          "Provide a SHA-256 hash (64 hex chars), an MD5 hash (32 hex chars) or a transaction ID.",
      });
      return;
    }

    setError(null);
    setLoading(true);

    const isHash = isSha256 || isMd5;

    if (!isHash) {
      navigate(`${currentUrl}?txId=${encodeURIComponent(hash)}`);
      return;
    }

    let response = await getBBData(hash);
    let url = `${currentUrl}?BBHash=${encodeURIComponent(hash)}`;
    if (response.status === 200) {
      navigate(url);
      setLoading(false);
      return;
    }

    response = await getDocumentData(hash, false);

    url = `${currentUrl}?documentHash=${encodeURIComponent(hash)}`;
    if (response.status === 200) {
      navigate(url);
      setLoading(false);
      return;
    }

    response = await getBlockHashData(hash, "", "", hash);
    setLoading(false);

    if (response.status === 200) {
      url = `${currentUrl}?txId=${encodeURIComponent(hash)}`;
      navigate(url);
      return;
    }

    setError({
      title: "Not found",
      message:
        "No notarized document, Blackbox stamp, transaction or block matches this hash.",
    });
    return;
  };

  function handleInputChange(e: any) {
    e.preventDefault();
    setSearchHash(e.target.value);
    onSearchStringChange(e.target.value as string);
  }

  return (
    <>
      <form
        onSubmit={(e) => {
          handleSearchSubmit(e);
        }}
        className="SearchBar"
      >
        <input
          placeholder="Insert a document hash, transaction ID or a block hash"
          onChange={handleInputChange}
          value={value}
        />
        <img
          alt="Explore"
          src={searchIcon}
          onClick={(e) => handleSearchSubmit(e)}
        ></img>
      </form>
    </>
  );
}

export default SearchBar;
